import React, { Fragment } from 'react'
import * as Sentry from "@sentry/react";

import { useTheme } from "Hooks/useTheme";
import axios from 'lib/axios'
import { ListGroup, OverlayTrigger, Popover } from 'react-bootstrap'

const Avatar = ({ currentUser, logOutPath, avatarUrl, menuPlacement = 'top' }) => (
  <OverlayTrigger key={'userInfo'} placement={menuPlacement} trigger="click" overlay={
    <Popover id="userInfo">
      <Popover.Body>
        <ListGroup>
          <ListGroup.Item style={{ paddingLeft: 0 }}>
            <button className='button__link' onClick={() => useTheme()}>
              Change Theme
            </button>
          </ListGroup.Item>
          <ListGroup.Item style={{ paddingLeft: 0 }}>
            <button className='button__link' onClick={() => window.location = '/api/authorization'}>
              API Secrets
            </button>
          </ListGroup.Item>
          <ListGroup.Item style={{ paddingLeft: 0 }}>
            <button className='button__link' onClick={() => Sentry.showReportDialog({
              user: { name: currentUser.name, email: currentUser.user_principal_name },
              title: 'Give us your feedback!',
              subtitle: '',
              subtitle2: '',
              labelComments: 'Feedback'
            })}>
              Give feedback
            </button>
          </ListGroup.Item>
          <ListGroup.Item style={{ paddingLeft: 0 }}>
            <button className='button__link' onClick={() => axios.post(logOutPath).then(() => { window.location = '/' })}>
              Sign out
            </button>
          </ListGroup.Item>
        </ListGroup>
      </Popover.Body>
    </Popover>
  }>
    <div className="user-profile">
      <img className='user-profile__avatar' src={avatarUrl} alt='Avatar' />
      <div className="user-profile__settings-overlay" />

      <div className="user-profile__info">
        <h6>
          <p style={{ margin: 0 }}>{currentUser.name}</p>
          <p style={{ margin: 0 }}>{currentUser.job_title}</p>
        </h6>
      </div>
    </div>
  </OverlayTrigger>
)

export default Avatar
